// src/components/store/sections/hero-banner/HeroV100PodiumspotlightTealLagoon.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV100PodiumspotlightTealLagoon(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={100}
      archKey="podium_spotlight"
      archLabel="3D Podium Spotlight"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      {...props}
    />
  );
}
